

















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { DrivewealthWizardStep } from "@/shared/types";
import SharedAccountCreationPage from "./SharedAccountCreationPage.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import InvestmentHeaderWithLogo from "@/shared/components/investments/drivewealth/InvestmentHeaderWithLogo.vue";
import * as RouteNames from "@/employee/route-names";
import { useWizardStore } from "@/employee/store/wizard";

@Component({
  components: {
    SharedAccountCreationPage,
    RiskDisclaimer,
    InvestmentHeaderWithLogo
  }
})
export default class PreenrollmentPage extends Vue {
  wizardStore = useWizardStore();

  @Prop({ required: true })
  step: DrivewealthWizardStep; // from the url

  @Prop({ required: true })
  wizardNavigationRouteName: string;

  @Prop({ default: true })
  showTitle: boolean;


  get showQuizLogo () {
    return this.step === DrivewealthWizardStep.PortfolioSelection ||
        this.step === DrivewealthWizardStep.PortfolioConfirmation;
  }

  get isOnboarding () {
    return this.$route.name === RouteNames.OnboardingDrivewealthPreenrollment;
  }

  onWizardComplete () {
    if (this.wizardStore.isComplete === true) {
      this.$router.push({ name: RouteNames.DrivewealthSignupSweep });
    } else {
      this.wizardStore.setStepKeyComplete("investments")
          .then(() => this.$router.push({
            name: RouteNames.NamedOnboarding,
            params: {
              stepKey: this.wizardStore.maxAllowedStepKey
            }
          }));
    }
  }
}
